module.exports = __webpack_public_path__ + "img/logo.0063106e.png";